export default __webpack_public_path__ + "static/media/disabled-terminal.1623f524.svg";